module.exports = __webpack_public_path__ + "static/media/Cooked_Blue_Cap.333662de.webp";